
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pokal/grand-opening",
      function () {
        return require("private-next-pages/pokal/grand-opening/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pokal/grand-opening"])
      });
    }
  